export const parseGuestCount = (value) => {
  if (typeof value === "number") {
    return Number.isInteger(value) && value > 0 ? value : Number.NaN;
  }

  if (typeof value !== "string") {
    return Number.NaN;
  }

  const normalizedValue = value.trim();

  if (!normalizedValue) {
    return Number.NaN;
  }

  const plusMatch = normalizedValue.match(/^(\d+)\+$/);

  if (plusMatch) {
    return Number.NaN;
  }

  const parsedValue = Number(normalizedValue);

  return Number.isInteger(parsedValue) && parsedValue > 0
    ? parsedValue
    : Number.NaN;
};

export const normalizeGuestCount = (value, fallback = 0) => {
  const parsedValue = parseGuestCount(value);

  return Number.isInteger(parsedValue) && parsedValue > 0
    ? parsedValue
    : fallback;
};
